import { Injectable } from "@angular/core";
import { AlertController, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "@shared/services/user.service";
import { ConnectionStateService } from "@shared/services/connection-state.service";
import { Capacitor } from "@capacitor/core";
import { InAppReview } from '@capacitor-community/in-app-review';
import { webVersion } from 'src/environments/environment';
import { Preferences } from "@capacitor/preferences";
import { NativeSettings } from "capacitor-native-settings";
import {AppLauncher} from '@capacitor/app-launcher';
import { LanguageEnum } from "@shared/enums/LanguageEnum";
import { App } from "@capacitor/app";
@Injectable({
  providedIn: 'root'
})
export class UtilService {
    public static loggedOut: boolean = false;
    public appName: string = '';
    public versionNumber: string = '';

    private static serverUnreacheableMsg: string = 'unableToConnectMsg';
    private static serverUnreacheableMsgTime: number = 4000;
    private isAndroid: boolean;
    private openInAppReview:boolean = false;
    private callInAppReview:boolean = false;
    private lastConnectionToastTime: number = 0;
    private connectionToastVisible: boolean = false;
    constructor(
        private toastCtrl: ToastController,
        private platform: Platform,
        private translate: TranslateService,
        private alertCtrl: AlertController,
        private connectionStateService: ConnectionStateService,
    ){
      this.isAndroid = this.platform.is('android');

      App.addListener('pause', () => {
        if(this.callInAppReview){
          this.openInAppReview = true;
        }

      });

      this.collectVersionInfo();
    }


    public collectVersionInfo(){
      if (Capacitor.isNativePlatform()) {
        App.getInfo().then((val) => {
          if(val != null){
            console.log('this.appVersion.getAppName(): ' + val.name);
            this.appName = val.name;
            console.log('this.appVersion.getVersionNumber(): ' + val);
            this.versionNumber = val.version;
          } 
        })
      } else {
        this.versionNumber = webVersion
      }
    }


    public isNative(): boolean {
        //alert(document.URL);
        return Capacitor.isNativePlatform();
    }

    public async initTranslate() {

      this.translate.setDefaultLang('en');

      await Preferences.get({key:'USER_DATA'}).then(async (val:any)=>{
        val = val.value ? JSON.parse(val.value) : null;

        // console.log('val: ' + JSON.stringify(val.language));
        if (val != undefined && val != null && val.language != undefined && val.language != null && (val.setLanguageManually || val.language != 'en')) {
          console.log('initTranslate val.language: ' + val.language);
          this.translate.use(val.language); // Set user's saved language
          return;
        }  else {
          // alert('initTranslate else')
          let browserLanguage = this.translate.getBrowserLang();
  
          if (browserLanguage !== undefined && browserLanguage != null) {
            console.log('this.translate.getBrowserLang(): ' + browserLanguage);
            if (browserLanguage == LanguageEnum.PT) {
              this.translate.use(browserLanguage);
            }
            else if (browserLanguage == LanguageEnum.DA) {
              this.translate.use(browserLanguage);
            }
            else if (browserLanguage == LanguageEnum.KO) {
              this.translate.use(browserLanguage);
            }
            else if (browserLanguage == LanguageEnum.PL) {
              this.translate.use(browserLanguage);
            }
            else if (browserLanguage == LanguageEnum.IT) {
              this.translate.use(browserLanguage);
            }
            else if (browserLanguage == LanguageEnum.FR) {
              this.translate.use(browserLanguage);
            }
            else if (browserLanguage == LanguageEnum.DE) {
              this.translate.use(browserLanguage);
            }
            else if (browserLanguage == LanguageEnum.ES) {
              this.translate.use(browserLanguage);
            }
            else {
              this.translate.use(LanguageEnum.EN);
            }
    
          }
          else {
            this.translate.use(LanguageEnum.EN);
          }
        }
      })
  
      
    
    
    }


    async presentToast(toastCtrl: ToastController,msg: string, dur: number) {

      let toast = await toastCtrl.create({
        message: msg,
        duration: dur,
        buttons: [
          {
            text: this.translate.instant('close'),
            role: 'cancel',
          }
        ],
  
      });
      toast.present();
    }

    public showToastUnableToConnect(toastCtrl: ToastController) {
      // Só exibe se realmente deve mostrar erro de conexão
      try {
        if (this.connectionStateService.shouldShowConnectionError()) {
          this.presentToast(toastCtrl, this.translate.instant(UtilService.serverUnreacheableMsg), UtilService.serverUnreacheableMsgTime)
        }
      } catch (error) {
        console.error('Error in showToastUnableToConnect:', error);
        // Fallback para exibir toast sem verificação de estado
        this.presentToast(toastCtrl, this.translate.instant(UtilService.serverUnreacheableMsg), UtilService.serverUnreacheableMsgTime)
      }
    }

    public showTopToastUnableToConnect(toastCtrl: ToastController) {
      // Só exibe se realmente deve mostrar erro de conexão
      try {
        if (this.connectionStateService.shouldShowConnectionError()) {
          this.presentTopToast(toastCtrl, this.translate.instant(UserService.serverUnreacheableMsg), UserService.serverUnreacheableMsgTime)
        }
      } catch (error) {
        console.error('Error in showTopToastUnableToConnect:', error);
        // Fallback para exibir toast sem verificação de estado
        this.presentTopToast(toastCtrl, this.translate.instant(UserService.serverUnreacheableMsg), UserService.serverUnreacheableMsgTime)
      }
    }

    public async presentTopToast(toastCtrl: ToastController, msg: string, dur: number) {
      const now = Date.now();
      // Só exibe se já passou 30 segundos desde o último toast (reduzido de 1 minuto)
      if (this.connectionToastVisible || (now - this.lastConnectionToastTime < 30000)) return;
      this.connectionToastVisible = true;
      this.lastConnectionToastTime = now;
      let toast = await toastCtrl.create({
        message: msg,
        position: 'top',
        duration: dur,
        buttons: [
          {
            text: this.translate.instant('close'),
            role: 'cancel',
          }
        ],
      });
      toast.onDidDismiss().then(() => {
        this.connectionToastVisible = false;
      });
      toast.present();
    }

    public async presentTopToastGreen(toastCtrl: ToastController, msg: string, dur: number) {
      let toast = toastCtrl.create({
        message: msg,
        cssClass: 'sucessToastText',
        position: 'top',
        duration: dur,
        buttons: [
          {
            text: this.translate.instant('close'),
            role: 'cancel',
          }
        ],
  
      });
      (await toast).present();
    }

    public async showAlertRateNow(){

      console.log('showAlertRateNow');
      let alert = this.alertCtrl.create({
        header: this.translate.instant('enjoyingSoFar'),
        buttons: [
          {
            text: this.translate.instant('notReally'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('yes'),
            role:'confirm',
            handler: async () => {

              this.callInAppReview = true;
              await InAppReview.requestReview();

              setTimeout(async () => {
                if(!this.openInAppReview){
                  
                  this.showAlertWouldYouRateUs();
                  
                }
              }, 1000);

              setTimeout(async () => {
                this.callInAppReview = false;
                this.openInAppReview = false;
              }, 5000);



              // if (this.isAndroid) {
              //   this.showAlertWouldYouRateUs();
              // } else{
              //   RateApp.requestReview();
              // }

            }
          }
        ]
      });
  
      (await alert).present();
    }

    public async showAlertRateNowChat(){
      console.log('showAlertRateNow');
      let alert = this.alertCtrl.create({
        header: this.translate.instant('enjoyingSoFar'),
        buttons: [
          {
            text: this.translate.instant('notReally'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('yes'),
            role:'confirm',
            handler: async () => {
              this.showAlertWouldYouRateUs();
            }
          }
        ]
      });
  
      (await alert).present();
    }


    public async showAlertWouldYouRateUs(){
      let alert = this.alertCtrl.create({
        header: this.translate.instant('wouldYouRateUs'),
        subHeader: this.translate.instant('goodReviewHelps'),
        buttons: [

          {
            text: this.translate.instant('noThanks'),
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            },
          },
          {
            text: this.translate.instant('rateNow'),
            handler: async () => { 
              console.log(this.appName);

              if(this.appName === 'Flamr'){
                if(this.isAndroid){
                  await AppLauncher.openUrl({url: 'https://play.google.com/store/apps/details?id=com.leftyapp'});
                } else {
                  await AppLauncher.openUrl({url: 'https://apps.apple.com/br/app/lefty-namoro-da-esquerda/id1619368686'});
                }
              } else {
                if(this.isAndroid){
                  await AppLauncher.openUrl({url: 'https://play.google.com/store/apps/details?id=com.veggly'});
                } else {
                  await AppLauncher.openUrl({url: 'https://apps.apple.com/br/app/veggly-namoro-vegano/id1418079413'});
                }
              }
              
              // RateApp.requestReview();
            }
          },
        ]
      });
      
      (await alert).present();
      
    }

    

    async showModalAlert(message: any) {
      let alert = this.alertCtrl.create({
        //title: this.translate.instant('statisticalOnly'),
        subHeader: message,
        buttons: [
          // {
          //   text: this.translate.instant('cancel'),
          //   handler: () => {
          //     console.log('cancel clicked');
          //     return;
  
          //   }
          // },
          {
            text: 'OK',
            handler: () => { }
          }
        ]
      });
  
      (await alert).present();
    }
  

    async showModalAlertRequestPermission(message: any, Androidcommand:any, IOScommand:any) {
      let alert = this.alertCtrl.create({
        subHeader: message,
        buttons: [
          {
            text: this.translate.instant('notNow'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('toAllow'),
            handler: () => { 
              NativeSettings.open({
                optionAndroid: Androidcommand, 
                optionIOS: IOScommand
              })
            }
          }
        ]
      });

      (await alert).present();
    }
  

    
}